import {PrintData} from "./print-data";
import {urlToJson} from "./url-to-json";


/**
 * (ZPL) 출고보류라벨 출력데이터
 */
export default new PrintData({
    id: '',
    desc: 'ZPL방식 출고보류라벨 출력',

    makeQzDataPromise: async (house_id) => {
        let url = `/houses/${house_id}/shipout-hold-label`;

        return urlToJson(url)
            .then((res) => {
                return new Promise((resolve, reject) => {

                    // 송장 여러장 오면 여러장 모두 배열에 담아전달
                    // 담긴만큼 여러장 모두 출력됨.
                    let data = [];
                    res.zpls.forEach((zpl) => {
                        data.push(...zpl);
                    });
                    resolve(data);
                    console.log('zpl 출고보류라벨 데이터 생성완료!');

                });
            });


    },
})